import Organization from ".";
import TabsNavigation from "../../../../components/elements/TabsNavigation";

const tabRoutes = [
  // {
  //   label: "List",
  //   icon: "fa-regular fa-building",
  //   path: "/admin/organization",
  // },
];

export const organizationRoutes = (data) => [
  {
    path: "/admin/company",
    component: () => (
      <>
        {/* <TabsNavigation title="Company Management" tabRoutes={tabRoutes}>
          <Organization />
        </TabsNavigation> */}
        <div className="space-y-4 w-full flex flex-col pb-10">
          <div className="space-y-2 xls:space-y-6">
            <div className="text-lg xls:text-3xl text-bunker font-semibold">
              Company Management
            </div>
            <Organization />
          </div>
        </div>
      </>

    ),
    title: "Page",
    layout: "admin",
    routeType: "admin",
  },
];
